export class ManageServiceBO {
   orderColumn: string = "";
   orderType: string = "asc";
   pageitem: number = 10;
   currentpageno: number = 1;
   userId: string = "00000000-0000-0000-0000-000000000000";
   type: string = "";
   field: string = "";
   value: string = "";
   matchCase: boolean = false;
   operator: string = "startswith";
   serviceGroupId: string = "00000000-0000-0000-0000-000000000000";
}


export class saveServiceGroup {
   id: string = "00000000-0000-0000-0000-000000000000";
   serviceGroupName: string;
}




export class saveServiceBO {
   id: string = "00000000-0000-0000-0000-000000000000";
   serviceGroupId: string;
   serviceName: string;
   serviceCode: string;
   modifier1: string;
   modifier2: string;
   modifier3: string;
   modifier4: string;
   ratio: number;
   description: string;
   excludeFromBudget: boolean;
   serviceLocationCode: string;
   isTransportation:boolean;
   serviceTypeLid:string;
}

export class saveActivityBO {
   id: string = "00000000-0000-0000-0000-000000000000";
   activityCode: string;
   activityName: string;
}


export class saveMasterServiceActivityBO {
   id: string = "00000000-0000-0000-0000-000000000000";
   serviceId: string;
   serviceGroupId: string;
   serviceGroupName: string;
   serviceCode: string;
   activityId: string;
   MasterServiceName: string;

}
export class serviceactivityBO {
   currentpageno: number = 1;
   pageitem: number = 10;
   orderColumn: string = "masterServiceName";
   orderType: string = "asc";

   type: string = "";
   field: string = "";
   value: string = "";
   matchCase: boolean = false;
   operator: string = "startswith";
   statusLid:string=""
}
export class functionpermission {


   servicegroupcreate: boolean = true;
   servicegroupupdate: boolean = true;
   servicegroupdelete: boolean = true;

   servicecreate: boolean = true;
   serviceupdate: boolean = true;
   servicedelete: boolean = true;

   activitycreate: boolean = true;
   activityupdate: boolean = true;
   activitydelete: boolean = true;

   serviceactivitymappingcreate: boolean = true;
   serviceactivitymappingupdate: boolean = true;


}



export class ServiceTaxBO {
    id: string;
    serviceId: string;
    serviceGroupName: string;
    taxId: string;
    masterServiceName: string;
    taxName: string;
    statusLid:number;
}